import { render, staticRenderFns } from "./SignInPC.vue?vue&type=template&id=edfdbb6e&scoped=true&"
import script from "./SignInPC.vue?vue&type=script&lang=js&"
export * from "./SignInPC.vue?vue&type=script&lang=js&"
import style0 from "./SignInPC.vue?vue&type=style&index=0&id=edfdbb6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfdbb6e",
  null
  
)

export default component.exports